import { EntityGridList } from "@/modules/common/components";
import { Pagination } from "@/modules/common/types/Pagination";
import { AdminAneelTariffImportHistoryResponse } from "@/service/response/admin-aneel-tariffs";

import ImportHistoryListHeader from "./ImportHistoryListHeader";
import ImportHistoryListLine from "./ImportHistoryListLine";
import ImportHistoryListSkeleton from "./ImportHistoryListSkeleton";

interface ImportHistoryListProps {
  data?: Pagination<AdminAneelTariffImportHistoryResponse>;
  isLoading?: boolean;
  isFetching?: boolean;
  limit?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextSize: number) => void;
}

const ImportHistoryList = (props: ImportHistoryListProps) => (
  <EntityGridList
    {...props}
    minWidthClassName="md:min-w-[1200px]"
    renderHeader={() => <ImportHistoryListHeader />}
    renderRow={(importHistory) => <ImportHistoryListLine importHistory={importHistory} />}
    renderSkeleton={(limit) => <ImportHistoryListSkeleton limit={limit} />}
  />
);

export default ImportHistoryList;
